<template>
  <div>
    <div class="dummy2"/>
    <div class="detail"
         :style="`width:${changeBrowserSize.width > 500 ? '480px' : '100%'};padding:${changeBrowserSize.width > 500 ? '40px' : '20px'};`"
    >
      <div class="cookie-header">
        <img
            class="logo"
            alt="logo"
            src="../cookies/logo.png"
        />
        <img
            class="ic-close"
            alt="close"
            src="../cookies/ic-close.png"
            v-on:click="$emit('onClose')"
        />
      </div>
      <div class="contents"
           style="padding-right: 10px;display: block;"
      >
        <div class="title">
          {{this.$t('cookies.detail.main.title')}}
        </div>
        <div class="dec">
          {{this.$t('cookies.detail.main.dec01')}}
        </div>
        <button
            class="btn_b"
            @click="handleClick(0)"
        >
          {{this.$t('cookies.detail.main.btn')}}
        </button>
        <div class="title">
          {{this.$t('cookies.detail.sub.title')}}
        </div>
        <div class="btnItem">
          <span class="title">
            {{this.$t('cookies.detail.sub.subItem01.title')}}
          </span>
        </div>
        <div class="dec border">
          {{this.$t('cookies.detail.sub.subItem01.dec')}}
        </div>
        <div class="btnItem">
          <span class="title">
            {{this.$t('cookies.detail.sub.subItem02.title')}}
          </span>
          <span class="edit_mode_btn">
          <label
              class="patient_add pointer edit_patient_checkbox"
          >
            <input
                type="checkbox"
                id="performanceCookies"
                v-model="performanceCookies"
            >
            <label for="performanceCookies">
              <span/>
            </label>
          </label>
          <span class="edit_mode_title no-drag">
          </span>
        </span>
        </div>
        <div class="dec border">
          {{this.$t('cookies.detail.sub.subItem02.dec')}}
        </div>
        <div class="btnItem">
          <span class="title">
            {{this.$t('cookies.detail.sub.subItem03.title')}}
          </span>
          <span class="edit_mode_btn">
          <label
              class="patient_add pointer edit_patient_checkbox"
          >
            <input
                type="checkbox"
                id="functionalCookies"
                v-model="functionalCookies"
            >
            <label for="functionalCookies">
              <span/>
            </label>
          </label>
          <span class="edit_mode_title no-drag">
          </span>
        </span>
        </div>
        <div class="dec">
          {{this.$t('cookies.detail.sub.subItem03.dec')}}
        </div>
        <button
            class="btn_b"
            @click="handleClick(1)"
        >
          {{this.$t('cookies.detail.sub.btn01')}}
        </button>
        <button
            class="btn_w"
            @click="handleClick(2)"
        >
          {{this.$t('cookies.detail.sub.btn02')}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { getCookie } from '@/static';

export default {
  name: 'detailSetting',
  components: {},
  props: [
    'onAccept',
    'onClose'
  ],
  data() {
    // 초기 데이터
    return {
      performanceCookies: getCookie('performanceCookies') === '1',
      functionalCookies: getCookie('functionalCookies') === '1',
      oriPerformanceCookies: getCookie('performanceCookies') === '1',
      oriFunctionalCookies: getCookie('functionalCookies') === '1',
      innerWidth: window.innerWidth,
    }
  },
  methods: {
    /**
     *
     * @param type 0:모두, 1:선택만, 2:필수만
     */
    handleClick(type) {
      let performance = false;
      let functionalCookies = false;
      let eventFlag = false;

      switch (type) {
        case 0:
          performance = true;
          functionalCookies = true;
          break;
        case 1:
          performance = this.performanceCookies;
          functionalCookies = this.functionalCookies;
          break;
        case 2:
        default:
          break;
      }

      if (getCookie('performanceCookies') === "" && getCookie('functionalCookies') === "") {
        this.$emit('onAccept', performance, functionalCookies)
      } else {
        eventFlag = performance !== this.oriPerformanceCookies || functionalCookies !== this.oriFunctionalCookies;
        eventFlag ? this.$emit('onAccept', performance, functionalCookies) : this.$emit('onClose');
      }
    }
  },
  computed: {
    changeBrowserSize() {
      return this.$store.getters.getBrowserSize;
    },
  },
  watch: {},
}
</script>
<style lang="scss">
.dummy2 {
  z-index: 1000002;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000000;
  opacity: 0.2;
}

.detail {
  z-index: 1000003;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 40px;
  background-color: #fff;

  .cookie-header {
    width: 100%;
    height: 40px;
    margin-bottom: 10px;
  }

  .contents {
    width: 100%;
    height: calc(100% - 50px);
    overflow-y: auto;

    .title {
      height: 26px;
      margin: 60px 0 32px;
      font-size: 20px;
      font-weight: bold;
      text-align: left;
      color: #3b3a39;
    }

    .dec {
      margin: 20px 0 0;
      padding-bottom: 20px;
    }

    .border {
      border-bottom: 1px solid var(--grey50);
    }

    .btnItem {
      height: 30px;
      margin: 10px 0 10px 0;

      .edit_mode_btn {
        float: right;
        margin-top: 8px;
        margin-right: 4px;

        .patient_add {
          position: relative;
        }
      }

      .title {
        font-size: 16px;
        color: #3b3a39;
        line-height: 30px;
        vertical-align: middle;
      }
    }

    .btn_b {
      cursor: pointer;
      width: 100%;
      height: 39px;
      border-radius: 2px;
      font-size: 15px;
      background-color: #2a589f;
      color: #fff;
      border: 0;
      margin: 10px 0 10px 0;
    }

    .btn_b:hover {
      background-color: #1d4486;
    }

    .btn_w {
      cursor: pointer;
      width: 100%;
      height: 39px;
      border-radius: 2px;
      font-size: 15px;
      background-color: #fff;
      color: #2a589f;
      border: 0;
      margin: 10px 0 10px 0;
    }

    .btn_w:hover {
      text-decoration: none;
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
}

img.logo {
  width: 138px;
  height: 39px;
  float: left;
}

img.ic-close {
  width: 24px;
  height: 24px;
  float: right;
  cursor: pointer;
}
</style>